/**
 * 广告 接口的统一出口
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/';

const mediaCategory = {
    // 列表
    list(params) {
        return  axios.get(api + 'media/categorylist',{params:params});
    },
    // 添加
    create (params) {
        return axios.post(api + 'media/createcategory',qs.stringify(params))
    },
    // 修改
    edit (params) {
        return axios.post(api + 'media/editcategory',qs.stringify(params))
    },
    // 单个查看
    detail (params) {
        return axios.get(api + 'media/categorydetail',{params:params})
    },
    // 删除
    remove (params) {
        return axios.post(api + 'media/removecategory',qs.stringify(params))
    },
    // 所有
    all (params) {
        return axios.get(api + 'media/categoryall',{params:params})
    },
}


// 导出接口
export default mediaCategory